export default __webpack_public_path__ + "static/media/setting.906684cf.svg";